module.exports = __webpack_public_path__ + "src/asset/svg/title/history2.svg?42a24660fd5b29fa5863ac84bbc6716c";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/title/history2.svg
// module id = 99
// module chunks = 0